import { render, staticRenderFns } from "./BankSlip.vue?vue&type=template&id=0d99506c&scoped=true&"
import script from "./BankSlip.vue?vue&type=script&lang=js&"
export * from "./BankSlip.vue?vue&type=script&lang=js&"
import style0 from "./BankSlip.vue?vue&type=style&index=0&id=0d99506c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d99506c",
  null
  
)

export default component.exports